import Link from 'next/link';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';

import { Fonts, TextColors } from '../../../styleConstants';

const StyledAnchor = styled.a`
  color: ${({ color }) => TextColors[color]};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  font-size: ${Fonts.P2};
  font-weight: ${Fonts.REGULAR};
  ${({ anchorStyle }) => anchorStyle}
`;

const StyledDiv = styled.div`
  color: ${({ color }) => TextColors[color]};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  font-size: ${Fonts.P2};
  font-weight: ${Fonts.REGULAR};
  cursor: pointer;
  ${({ anchorStyle }) => anchorStyle}
`;

const Anchor = forwardRef(
  (
    { href, onClick, children, className, newTab, anchorStyle, disabled },
    ref
  ) => (
    <StyledAnchor
      anchorStyle={anchorStyle}
      className={className}
      href={href}
      ref={ref}
      onClick={onClick}
      target={newTab ? '_blank' : null}
      disabled={disabled}
    >
      {children}
    </StyledAnchor>
  )
);

Anchor.displayName = 'Anchor';

Anchor.propTypes = {
  href: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(PropTypes.any)
  ]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  newTab: PropTypes.bool,
  anchorStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(PropTypes.any)
  ]),
  disabled: PropTypes.bool
};

Anchor.defaultProps = {
  className: '',
  onClick: () => {},
  href: null,
  newTab: false,
  anchorStyle: '',
  disabled: false
};

const StyledLink = ({
  href,
  className,
  prefetch,
  children,
  onClick,
  as,
  color,
  newTab,
  anchorStyle,
  disabled
}) => {
  if (disabled) {
    const onAnchorClick = (e) => {
      e.preventDefault();
      onClick(e);
    };
    return (
      <StyledDiv
        color={color}
        onClick={onAnchorClick}
        anchorStyle={anchorStyle}
        className={className}
      >
        {children}
      </StyledDiv>
    );
  }
  return (
    <Link href={href} passHref prefetch={prefetch} as={as} scroll>
      <Anchor
        color={color}
        onClick={onClick}
        className={className}
        anchorStyle={anchorStyle}
        newTab={newTab}
        disabled={disabled}
      >
        {children}
      </Anchor>
    </Link>
  );
};

StyledLink.propTypes = {
  href: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(PropTypes.any)
  ]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  prefetch: PropTypes.bool,
  onClick: PropTypes.func,
  as: PropTypes.string,
  color: PropTypes.string,
  newTab: PropTypes.bool,
  anchorStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(PropTypes.any)
  ]),
  disabled: PropTypes.bool
};

StyledLink.defaultProps = {
  className: '',
  prefetch: false,
  onClick: () => {},
  as: null,
  href: null,
  color: 'BLACK',
  newTab: false,
  anchorStyle: '',
  disabled: false
};

export default StyledLink;
